import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { InfoPage } from 'components/common/Layout/InfoPage/InfoPage';

import { updateExtraByName } from 'actions/extraAction';

import { PERSONAL_DETAILS_UPDATED_SHOWN } from 'constants/amplitude/AmplitudeEvents';
import { USER_LOGIN_COUNTRY_ID } from 'constants/Constants';

import { resolveArguments, timer } from 'helpers/utils';

import amplitude from 'amplitude-js';
import { useAuth, useExtra, usePageMessages } from 'hooks/selectors';
import Cookies from 'universal-cookie';

import { DangerouslyHtml } from '../../../common/DangerouslyHtml/DangerouslyHtml';

const cookies = new Cookies();

const WelcomePage = (props) => {
    const { showSpecialWelcomeScreen, userName, isNewUser } = useExtra();
    const { countryId } = useAuth();
    const { welcomeMessage, gotIt, specialWelcomeScreenTitle, specialWelcomeScreenText } = usePageMessages();

    useEffect(() => {
        if (isNewUser) {
            amplitude.getInstance().logEvent(PERSONAL_DETAILS_UPDATED_SHOWN);
        }
        let loginCountryId = `${countryId}`;
        const countryCookie = cookies.get(USER_LOGIN_COUNTRY_ID);
        if (countryCookie !== undefined && countryCookie !== null && countryCookie !== 'undefined' && typeof countryCookie === 'string') {
            const countryCookieArr = countryCookie.split(',');
            loginCountryId = countryCookieArr.indexOf(loginCountryId) >= 0 ? `${countryCookie}` : `${countryCookie},${countryId}`;
        }
        cookies.set(USER_LOGIN_COUNTRY_ID, loginCountryId, { path: '/' });
        if (!showSpecialWelcomeScreen) {
            timer(null, props.hideWelcomePage, 2000);
        }
    }, []);

    let infoPageProps;
    if (showSpecialWelcomeScreen) {
        infoPageProps = {
            iconName: 'paysend-logo-circle',
            headerText: specialWelcomeScreenTitle,
            secondaryText: <DangerouslyHtml dangerouslyHtml={specialWelcomeScreenText} />,
            primaryButtonType: 'button',
            primaryButtonCaption: gotIt,
            primaryButtonOnClick: () => {
                props.updateExtraByName('welcomePage', false);
            },
        };
    } else {
        infoPageProps = {
            animatedIconSuccess: true,
            mainText: resolveArguments(welcomeMessage, userName),
        };
    }

    return <InfoPage {...infoPageProps} iconColor="purple" />;
};
WelcomePage.propTypes = {
    hideWelcomePage: PropTypes.func.isRequired,
};
export default connect(null, { updateExtraByName })(WelcomePage);
